import Logo from "components/Logo";
import { Link } from "react-router-dom";

export default function Footer() {
  const navigation = {
    main: [
      { name: "About", href: "/" },
      { name: "Opportunities", href: "/opportunities" },
      { name: "Supplier Directory", href: "/supplier-directory" },
      { name: "Help", href: "/" },
    ],
    legal: [
      { name: "Terms", href: "#" },
      { name: "Privacy", href: "#" },
      { name: "Cookies", href: "#" },
    ],
  };

  return (
    <footer className="bg-blue-800 mt-32">
      <div className="max-w-6xl mx-auto px-6 py-12 lg:px-8">
        <div className="flex flex-col items-center justify-between gap-6">
          {/* Logo */}
          <div className="flex items-center">
            <Link to="/">
              <img src="/logo-white.png" alt="" className="w-32" />
            </Link>
          </div>

          {/* Navigation */}
          <nav className="flex gap-8">
            {navigation.main.map((item) => (
              <a
                key={item.name}
                href={item.href}
                className="text-sm font-semibold text-white opacity-70 hover:text-gray-200"
              >
                {item.name}
              </a>
            ))}
          </nav>
        </div>

        {/* Divider */}
        <div className="mt-8 pt-8 border-t border-white/10">
          <div className="flex flex-col sm:flex-row items-center gap-4">
            {/* Copyright */}
            <p className="text-sm text-gray-300 font-light">
              © 2077 SoiSoft Ltd All rights reserved.
            </p>

            {/* Legal links */}
            <nav className="flex gap-6">
              {navigation.legal.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className="text-sm font-light text-gray-300 hover:text-white"
                >
                  {item.name}
                </a>
              ))}
            </nav>
          </div>
        </div>
      </div>
    </footer>
  );
}
